<motn-drawer-gap-from-top
  (clickedOutside$)="clickedOutside$.emit(null)"
>
  @if (editingSchedule) {
    <motn-schedule-editor
      [tile]=tile
      [schedule]=editingSchedule
      [allSchedules]=schedules
      (saved$)=saveEdits($event)
      (canceled$)=cancelEdits()
      (deleted$)=deleteSchedule($event)
    ></motn-schedule-editor>
  }

  <h3
    class="title"
  >
    <div
      class="left"
    >
      <div>
        <i class="far fa-{{tile.Appearance.Icon}}"></i>
        {{tile.Name}}
      </div>
      <motn-pill
        [squareLetter]="'t'"
      >{{ tile.ID }}</motn-pill>
    </div>

    <button
      class="small green"
      (click)=addSchedule()
    >
      Add Schedule
    </button>
  </h3>

  @if (tile) {
    <div
      class="content"
    >
      <div class="schedule-table">
        <div class="header">
          <div class="cell mobile-hide hour-label"></div>

          <div class="cell mobile-hide">Sun</div>
          <div class="cell mobile-hide">Mon</div>
          <div class="cell mobile-hide">Tue</div>
          <div class="cell mobile-hide">Wed</div>
          <div class="cell mobile-hide">Thu</div>
          <div class="cell mobile-hide">Fri</div>
          <div class="cell mobile-hide">Sat</div>

          @for (dow of mobileDaysOfWeek; track $index; let d = $index) {
            <div
              class="cell mobile-only"
              [class.mobile-show]="mobileDayShown === d"
            >
              <div
                class="dow"
              >
                <div (click)=mobileShowPreviousDay()>
                  <i class="fa-solid fa-angle-left"></i>
                </div>
                {{dow}}
                <div (click)=mobileShowNextDay()>
                  <i class="fa-solid fa-angle-right"></i>
                </div>
              </div>
            </div>
          }
        </div>

        @for (hourLabel of hourLabels; track $index; let i = $index) {
          <div
            class="row"
          >
            <div
              class="cell hour-label mobile-show"
              [innerHTML]=hourLabel
            >
            </div>

            @for (day of hourCells[i]; track $index; let d = $index) {
              <div
                class="cell mobile-hide"
                [class.mobile-show]="mobileDayShown === d"
              >
                @for (setting of day; track setting.uuid; let h = $index) {
                  <div
                    class="setting"
                    [class.disabled]=!setting.enabled
                    (click)=editSchedule(setting.uuid)
                  >
                    <div
                      class="time"
                    >
                      {{setting.timeOfDay}}
                    </div>

                    <div
                      class="value"
                    >
                      {{setting.displayValue}} {{tile.getUnitsLabel()}}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</motn-drawer-gap-from-top>
